export var COLOR_MAP = {
  GREY: 'grey',
  GREEN: 'green',
  ORANGE: 'orange',
  RED: 'red',
  YELLOW: 'yellow',
  BLACK: 'black',
  PLATINUM: 'platinum',
  BLUE: 'blue',
  BURNING_ORANGE: 'burningOrange',
  GOLD: 'gold',
  RIVER_BED_GRAY: 'riverBedGray',
  LIGHT_ORANGE: 'lightOrange'
};